import { render } from "./BottomBar.vue?vue&type=template&id=136a4e12&scoped=true"
import script from "./BottomBar.vue?vue&type=script&lang=js"
export * from "./BottomBar.vue?vue&type=script&lang=js"

import "./BottomBar.vue?vue&type=style&index=0&id=136a4e12&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Dell\\Documents\\eChook\\Code\\gpt-nano-configurator\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-136a4e12"]])

export default __exports__